import closeIcon from '@/components/Icons/Modals/IconClose.vue';

export default{
	mounted(){
		setTimeout(() => this.modalActive = true, 300);
	},

	data(){
		return{
			id: null,
			modalActive: false,
			responseReady: false,
			success: '',
			email : "",

			language_option: 'es',

			content: {
				title: "",
				text: "",
				question: ""
			},
		}
	},

	props: {
		title: String,
		text: String,
		question: String,
		callback: String,
	},
	
	components:{
		closeIcon,
	},

	methods:{
		closeModal(){
			this.$parent.modal_confirm.status = false;
		},
		back(status){
			if(status)
				this.$parent.modal_confirm.response = true;
			else
				this.$parent.modal_confirm.response = false;
			this.$parent.confirms(this.callback);
			this.$parent.modal_confirm.status = false;
		}
	}
}